import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { storeDetailsEvent } from '../../data-layer/actions.js';
import StoreBookAppointmentCTA$1 from './StoreBookAppointmentCTA.js';
import { getBookAppointmentUrl } from '../../utils/store-utils.js';

const StoreBookAppointmentCTAContainer = (_param)=>{
    var { url , code , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , storeCode , appointmentTypeId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "url",
        "code",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "storeCode",
        "appointmentTypeId"
    ]);
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const location = getBookAppointmentUrl(url, {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    })({
        code
    });
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            caption: getLabel('stores.page.details.action.bookAppointment')
        })
    , [
        getLabel
    ]);
    const onClick = React__default.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'book appointment click',
            store: {
                code,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        if (dataLayerEvent) {
            DataLayer.pushEvent(dataLayerEvent);
        }
        window.location.assign(location);
    }, [
        location,
        code,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode, 
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreBookAppointmentCTA$1, swcHelpers.extends({}, rest, {
        labels: labels,
        onClick: onClick
    }));
};
var StoreBookAppointmentCTA = StoreBookAppointmentCTAContainer;

export { StoreBookAppointmentCTA as default };
//# sourceMappingURL=StoreBookAppointmentCTAContainer.js.map
